// src/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, googleProvider } from './firebase'; // your firebase init file
//import { onAuthStateChanged, signInWithPopup, signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword } from "firebase/auth";
import { signInWithPopup, onAuthStateChanged, signOut, signInWithRedirect, getRedirectResult  } from "firebase/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Helper functions
  //const login = (email, password) => signInWithEmailAndPassword(auth, email, password);
  //const signup = (email, password) => createUserWithEmailAndPassword(auth, email, password);
  const logout = () => signOut(auth);

  // Inside your AuthProvider function:
	const loginWithGoogle = () => {
	  //return signInWithRedirect(auth, googleProvider);
	  return signInWithPopup(auth, googleProvider);
	};
	
	// Use useEffect to catch the result after the redirect back
	/*useEffect(() => {
	  getRedirectResult(auth).catch((error) => {
		console.error("Redirect Error:", error);
		alert('AuthProvider:getRedirectResult:'+error);
	  });
	}, [auth]);*/


  useEffect(() => {
    // This observer keeps the user state in sync with Firebase
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
	  //alert('AuthProvider:onAuthStateChanged:'+currentUser);
    });

    return () => unsubscribe(); // Cleanup on unmount
  }, [auth]);
  
    //<AuthContext.Provider value={{ user, login, loginWithGoogle, signup, logout, loginWithGoogle }}>
  return (
    <AuthContext.Provider value={{ user, loading, loginWithGoogle, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook for easy access
export const useAuth = () => {
	const context = useContext(AuthContext); // Ensure AuthContext is correctly imported
  if (context === undefined) {
	  //alert("AuthProvider:useAuth must be used within an AuthProvider")
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
